// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ecb555ef","885":"28ac9f51"}[chunkId] + ".chunk.js";
};